import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SearchIcon from "@atlaskit/icon/glyph/search";
import { media } from "@atlaskit/primitives/responsive";

const searchIconStyle = css({
    "marginInlineStart": "25px",
    "background": "transparent",
    "border": 0,
    "cursor": "pointer",
    "padding": 0,
    "color": "#64686f",
    "&:hover": {
        svg: {
            backgroundColor: "#dfe1e5"
        }
    },
    "svg": {
        color: "#64686f",
        borderRadius: "50%",
        height: "auto",
        padding: "5px",
        width: "32px",
        [media.below.md]: {
            width: "50px"
        }
    }
});

const SearchButton = (props: {
    readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
    const intl = useIntl();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "globalnav.v2.search.label",
            defaultMessage: "Search"
        })
    };

    return (
        <button
            css={searchIconStyle}
            onClick={props.onClick}
            id="global-nav-search-icon"
            aria-label={translated.searchLabel}
            data-testid="global-nav-search-icon"
            data-event="clicked"
            data-event-component="linkButton"
            data-event-container="globalNavWac"
            data-product-key="jiraSoftware"
        >
            <SearchIcon label={translated.searchLabel} />
        </button>
    );
};

export default SearchButton;
